(() => {
  invokersPolyfill();
  dialogClickOutside();
  invokersOpenState();

  function invokersPolyfill() {
    var isSupported = isSupportedFn();

    if (!isSupported) {
      var scriptEl = document.createElement('script');

      scriptEl.src = window.global.asset_url['js-vendor-invokers-polyfill@0.6.1.js'];
      scriptEl.async = true;

      document.head.appendChild(scriptEl);
    }

    function isSupportedFn() {
      return (
        typeof HTMLButtonElement !== 'undefined' &&
        'command' in HTMLButtonElement.prototype &&
        'source' in ((globalThis.CommandEvent || {}).prototype || {})
      );
    }
  };

  function dialogClickOutside() {
    document.addEventListener('click', (event) => {
      if (event.target.tagName == 'DIALOG') {
        event.target.close();
      }
    });
  };

  function invokersOpenState() {
    document.addEventListener('toggle', (event) => {
      if (!event.target.id) return;

      var trigger = document.querySelector(`[commandfor="${event.target.id}"]`);

      if (trigger) {
        trigger.classList.toggle('is-open', event.newState === 'open');
      }
    }, true);
  };
})();
